import React, { Component } from 'react';
import parse from 'html-react-parser';
import '../styles/work.scss';

class Work extends Component {
  render() {
    return (
      <div className="work-section">
        <section id="work-container">
           <div id="work"></div>
          <div className="section-container">
            <div className="content">
              <h1 className="title">Check out my featured work</h1>

              <div className="grid portfolio-container">

              <div className="gridwrap">
                <div className="inner-grid">

                  {this.props.items.map(( item, i ) => (

                    <div className={`grid-item ${item.url}`} key={`${item.portId}-port`}>
                      <div className="portfolio-bg">
                        <img src={`${process.env.PUBLIC_URL}/${item.image}`} alt={item.name}/>
                      </div>
                      <div className={`colorFilter filter${i+1}`}></div>
                      <div className="portfolio-desc">
                        <h2>{item.name}</h2>
                        <div className="info">
                          <p>{parse(item.bio)}</p>
                          <p>
                            <a className="base-link link" href={item.link}>
                            See it live
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>

                  ))}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     </div>
    );
  }
}

export default Work;
